<template>
  <div class="feedback">
    <!--面包屑-->
    <div class="Fixed">
      <div class="Fixed-left">
        <ul>
          <li @click="goToRouter"
              :class="{active:(routerShow === '/index/feedback/waitTask' || routerShow === '/index/feedback/waitParticular')}">待处理({{waitTotal}})</li>
          <li @click="goToRouter1"
              :class="{active:(routerShow === '/index/feedback/processed'|| routerShow === '/index/feedback/proParticular')}">已处理({{processedTotal}})</li>
        </ul>
      </div>
      <div class="Fixed-right">
        <Breadcrumb>
          <BreadcrumbItem>
            <a @click="goToHome" class="ivu-breadcrumb-item-link">
              <li  class="breader">首页</li>
            </a>
          </BreadcrumbItem>
          <BreadcrumbItem  v-for="item in routerMap" :key="item.index"
                           :to="item.path">
            <li class="breader">{{item.name}}</li>
          </BreadcrumbItem>
        </Breadcrumb>
      </div>
    </div>
    <!--内容-->
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import processed from './child/processed'
import waitTask from './child/waitTask'
import {goToHome} from '@/common/js/cookie'
export default {
  name: 'feedback',
  components: {
    processed,
    waitTask
  },
  computed: {
    // 面包屑路由获取
    routerMap () {
      let routerMap = this.$route.matched
      let routerMap1 = routerMap.concat()
      if (routerMap1.length > routerMap1.length - 1) {
        routerMap1.splice(routerMap1.length - 1, 1)
        routerMap1[routerMap1.length - 1].path = ''
        return routerMap1
      } else {
        return routerMap1
      }
    },
    routerShow () {
      let routerShow = this.$route.matched
      return routerShow[2].path
    }
  },
  data () {
    return {
      waitTotal: 0,
      processedTotal: 0
    }
  },
  mounted () {
    let that = this
    window.addEventListener('setItemEvent1', (e) => {
      that.waitTotal = e.newValue
    }, false)
    window.addEventListener('setItemEvent2', (e) => {
      that.processedTotal = e.newValue
    }, false)
  },
  methods: {
    goToHome () {
      goToHome()
    },
    // 待处理页面
    goToRouter () {
      this.liShow = false
      this.$router.push('waitTask')
    },
    // 已处理页面
    goToRouter1 () {
      this.liShow = true
      this.$router.push('processed')
    }
  }
}
</script>

<style scoped lang="stylus">
  .feedback
  .Fixed
    height .53rem;
    width 100%
    border-bottom 1px #cfd1d3 solid;
    box-shadow 1px 1px 5px 1px #d9dcde;
    .Fixed-left
      float left
      ul
        margin-left .3rem
        height .53rem
        li.active
          display inline
          float left
          width 1rem
          font-size .16rem
          line-height .52rem
          overflow hidden
          background-color: #fff;
          color: #15bc41;
          border-bottom: 1px solid #15bc41;
          box-sizing: border-box;
          transition: all .3s ease;
        li
          display inline
          float left
          width 1rem
          text-align center
          font-size .16rem
          line-height .52rem
          cursor: pointer

    .Fixed-right
      float right
      line-height: .53rem;
      margin-right .3rem;
      .breader
        font-size .16rem
        display inline

  .content
    padding .2rem .3rem 0 .3rem
</style>



// WEBPACK FOOTER //
// src/views/feedback/feedback.vue